import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await login(email, password);
      toast.success('Login berhasil!');
      
      // Redirect based on user role
      const userRole = response.data.user.role;
      if (userRole === 'kemahasiswaan' || userRole === 'wakil_ketua_3') {
        navigate('/kemahasiswaan/dashboard');
      } else {
        navigate('/kemahasiswaan/dashboard');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Login gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-brand">
          <div className="brand-content">
            <h1>Portal Admin</h1>
            <p>Sistem Manajemen Data Mahasiswa</p>
            <div className="features">
              <div className="feature">
                <span className="icon"></span>
                <span>Kelola data mahasiswa dengan mudah</span>
              </div>
              <div className="feature">
                <span className="icon"></span>
                <span>Sinkronisasi dengan Neo Feeder</span>
              </div>
              <div className="feature">
                <span className="icon"></span>
                <span>Akses cepat dan aman</span>
              </div>
            </div>
          </div>
        </div>
        <div className="login-form-section">
          <div className="form-wrapper">
            <div className="logo">
              <img src="/images/logo-stikes.png" alt="STIKES Baramuli Logo" style={{width: '100%', height: '100%', objectFit: 'contain'}} />
            </div>
            <h2>Sekolah Tinggi Ilmu Kesehatan Baramuli</h2>
            <p className="subtitle">Silakan login untuk melanjutkan</p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email / NIM</label>
                <input 
                  type="text" 
                  placeholder="Masukkan email atau NIM" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input 
                  type="password" 
                  placeholder="Masukkan password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                />
              </div>
              <p className="hint-text">
                <small>Mahasiswa gunakan NIM sebagai username dan password</small>
              </p>
              <button type="submit" disabled={loading}>
                {loading ? 'Memproses...' : 'Login'}
              </button>
            </form>
            <div className="footer">
              <p>&copy; 2024 Sekolah Tinggi Ilmu Kesehatan Baramuli. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;